import { ActionTypes } from "../contants/Action.Type";
import jwt from "jsonwebtoken";
const Auth = {
  Token: localStorage.getItem("Token") || "",
  isAuth: false,
  userData: jwt.decode(localStorage.Token) || [],
  Loading: false,
  lockScreen: false,
  lockPop: false,
  company: [],
};

export const authReducer = (state = Auth, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_LOGIN_TOKEN:
      return {
        ...state,
        Token: payload.Token,
        isAuth: payload.Auth,
        userData: payload.userData,
      };
    case ActionTypes.SET_LOGOUT:
      return {
        ...state,
        Token: payload.Token,
        isAuth: payload.Auth,
        userData: payload.userData,
        lockScreen: false,
        lockPop: false,
      };
    case ActionTypes.SET_LOADING:
      return { ...state, Loading: payload };
    case ActionTypes.SET_SCREEN_LOCK:
      return { ...state, lockScreen: payload };
    case ActionTypes.SET_SCREEN_UNLOCK:
      return { ...state, lockPop: payload };
    case ActionTypes.SET_COMPANY_INFO:
      return { ...state, company: payload };
    case ActionTypes.SET_SCREEN_AUTH:
      return {
        ...state,
        Token: payload.Token,
        isAuth: payload.Auth,
        userData: payload.userData,
        lockScreen: false,
        lockPop: false,
      };
    default:
      return state;
  }
};
